import { css, Theme } from "@emotion/react";

export const MForgotPassByPhoneStyle = {
  self: css`
    //
  `,
  content: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  optionList: css`
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,

  optionItemWrapper: css`
    height: 100%;
    border: none !important;
    border-radius: 0 !important;
    background-color: unset !important;
    &::before {
      display: none !important;
    }
  `,
  optionItem: ({ fontSize, colors }: Theme) => css`
    display: flex;
    align-items: center;
    padding: 8px 30px;
    border: 1px solid ${colors.orange[50]};
    border-radius: 30px;
    color: ${colors.orange[50]};
    gap: 10px;
    font-size: ${fontSize[16]};
    h4 {
      font-weight: 400;
    }
    svg,
    path {
      fill: ${colors.orange[50]};
      font-size: 20px;
    }
  `,
};
